import { Input } from 'antd';
import React from 'react';

export default function ProfileAccess() {
    return (
        <div>
            <div className='border rounded-lg p-4'>
                <p className='font-semibold text-lg border-b pb-3'>Profile Access</p>
                <div className='mt-3 mb-2'>
                    <p className='mb-1'>Email</p>
                    <Input size='large' type='email' placeholder='Enter email address' />
                </div>
            </div>
        </div>
    )
}
